var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWellpappKartong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2371_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5238 36.9775L50.2277 36.9129L48.7641 2.33833H44.0364L43.7369 0L23.7675 2.79442L5.56807 0.568414L5.0371 5.41865L0.5 6.05854L1.36113 12.7093L2.82811 24.2172L1.49047 34.7379L4.21001 35.0545L4.82607 39.8775L22.9575 37.3213V37.3145L45.1767 40L45.5204 36.9775H45.5238ZM36.014 35.4084L48.08 33.7202L47.6273 30.1974L48.2434 30.1668L48.4578 35.2383L36.0174 35.4118L36.014 35.4084ZM48.2059 29.3159L47.5184 29.3499L44.986 9.66644H47.3754L48.2093 29.3159H48.2059ZM46.1773 32.2669L25.1188 35.2144L24.4959 30.5718L45.5681 27.546L46.1739 32.2634L46.1773 32.2669ZM47.1372 4.04016L47.338 8.81552H44.8737L44.2577 4.04016H47.1338H47.1372ZM45.4626 26.7052L22.8928 29.9455L20.4558 10.5582L42.9813 7.41661L45.466 26.7086L45.4626 26.7052ZM20.1188 9.74472L19.918 9.77195L19.5538 9.82301L18.788 3.90402L19.387 3.97549L20.1222 9.74472H20.1188ZM42.8656 6.5725L21.8036 9.50987L21.2114 4.87406L23.7811 4.51327L24.0262 4.54391L24.033 4.47924L42.2665 1.92648L42.8656 6.5725ZM7.0725 2.46767L17.2052 3.7066L6.77638 5.17359L7.0725 2.46767ZM17.2665 5.41865L17.8656 10.0511L2.99489 12.066L2.40266 7.51191L17.2631 5.42206L17.2665 5.41865ZM3.39653 33.2471L3.68924 30.953L3.95133 33.0157L3.98877 33.3152L3.39653 33.2471ZM3.10381 12.9101L19.6048 10.6739L22.0419 30.0647L5.58509 32.369L3.10381 12.9101ZM6.29986 37.9544L5.69401 33.2165L20.4558 31.1504L21.0582 35.8782L6.29646 37.9578L6.29986 37.9544ZM22.144 30.9122L22.8111 30.8169L23.4612 35.6637L22.7396 35.5752L22.144 30.9088V30.9122ZM35.5068 37.1205L43.8118 37.0048L43.6858 38.1076L35.5068 37.1205Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2371_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7277,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWellpappKartong);
export default __webpack_public_path__ + "static/media/icon-wellpapp-kartong.17010c1dbc39e0faa6996910dd0e4e89.svg";
export { ForwardRef as ReactComponent };